// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__k8urI","description":"PatientConsentPreview_description__Z0rIi"};